import dayjs from "dayjs";
import { TimeRangePickerProps } from "antd";
export const funnelColors = [
  "#347094", // Tenant Invitation Sent
  "#4d87a9", // Kyc Submitted
  "#669dbd", // Deposit Paid
  "#80b4d1", // Rent Payments Received
  "#99cae5", // Contract Created
];
export const rangePresets: TimeRangePickerProps["presets"] = [
  { label: "Last 7 Days", value: [dayjs().add(-7, "d"), dayjs()] },
  { label: "Last 14 Days", value: [dayjs().add(-15, "d"), dayjs()] },
  { label: "Last 1 Month", value: [dayjs().add(-31, "d"), dayjs()] },
  { label: "Last 2 Months", value: [dayjs().add(-62, "d"), dayjs()] },
  { label: "Last 3 Months", value: [dayjs().add(-92, "d"), dayjs()] },
  { label: "Last 4 Months", value: [dayjs().add(-123, "d"), dayjs()] },
  { label: "Last 6 Months", value: [dayjs().add(-183, "d"), dayjs()] },
];

export const usagesTypeOption = [
  { key: "all", label: "All", value: "all" },
  {
    label: "Residential",
    value: "Residential",
  },
  { label: "Commercial", value: "Commercial" },
];
